






















helpers = require('../../helpers.coffee')

view_model =
  components:
    filters: require('../events/filters')
    rdStationEvent: require('../events/rd_station_event')
    pipedriveEvent: require('../events/pipedrive_event')
    hsEvent: require('../events/hs_event')
    pipedriveCreatedEvent: require('../events/pipedrive_created_event')
    sharpSpringEvent: require('../events/sharp_spring_event')
    leadLoversEvent: require('../events/lead_lovers_event')
    commentEvent: require('../events/comment_event')
    manualTaskEvent: require('../events/manual_task_event')
    event: require('../events/event')
    taskDestroyedEvent: require('../events/task_destroyed_event')

  data: ->
    contact: {}
    events: []
    filters: {}
    next_page: 1
    loading: false

  methods:
    contactLoaded: (data) ->
      @contact = data.contact
      @contact_events_resource = new ContactEventsResource @contact.id
      @loadEvents()

    addEvent: (event) ->
      @events.unshift event

    removeEvent: (event) ->
      @events.remove event.id

    eventUpdated: (event) ->
      @events.replaceById event

    loadEvents: ->
      return if !@contact_events_resource || @loading || !@next_page
      @loading = true
      return @loadNewEvents() if Session.current_user.extradata.new_contacts_events
      @contact_events_resource.index @loadEventsSuccess, @unknownError, params: { q: @filters, page: @next_page }

    loadNewEvents: ->
      path = "https://#{process.env.CONTACTS_EVENTS_URL + process.env.BASE_API_GATEWAY_URL}/contacts"
      headers =
        'authorization': process.env.LAMBDA_AUTORIZATION
        'x-user-token': Session.current_user.authentication_token

      jQuery.ajax({
        url: path,
        headers: headers,
        data: { q: @filters, page: @next_page, contact_id: @contact.id },
        success: @loadEventsSuccessNewEvents
        error: @unknownError
      })

    loadEventsSuccess: (resources) ->
      @events = @events.concat(resources.events)
      @next_page = resources.meta.next_page
      @loading = false

    loadEventsSuccessNewEvents: (resources) ->
      events = resources.events.map (event) -> new ContactEvent(event)
      @loadEventsSuccess({ events, meta: resources.meta })

    filter: (filters) ->
      @events = []
      @next_page = 1
      @filters = filters
      @loadEvents()

    eventComponent: (event) ->
      switch event.type()
        when 'CommentEvent' then 'comment-event'
        when 'ManualTaskEvent' then 'manual-task-event'
        when 'ContactCreatedByPipedriveEvent' then 'pipedrive-created-event'
        when 'ContactUpdatedByPipedriveEvent' then 'pipedrive-event'
        when 'ContactCreatedByRdStationEvent' then 'rd-station-event'
        when 'ContactUpdatedByRdStationEvent' then 'rd-station-event'
        when 'ContactCreatedByHubspotEvent' then 'hs-event'
        when 'ContactUpdatedByHubspotEvent' then 'hs-event'
        when 'ContactCreatedBySharpSpringEvent' then 'sharp-spring-event'
        when 'ContactUpdatedBySharpSpringEvent' then 'sharp-spring-event'
        when 'ContactCreatedByLeadLoversEvent' then 'lead-lovers-event'
        when 'ContactUpdatedByLeadLoversEvent' then 'lead-lovers-event'
        when 'TaskDestroyedEvent' then 'task-destroyed-event'
        else 'event'

    handleToggleDone: (task) ->
      manual_task_event = new ContactEvent({
        description: null,
        detailed_type: 'ManualTaskEvent',
        title: task.text,
        created_at: task.done_at
      })
      manual_task_event.task = new Task(task)
      @addEvent(manual_task_event)

  created: ->
    EventsBus.$on 'contact-loaded', @contactLoaded
    EventsBus.$on 'Task::Done', @handleToggleDone

  beforeDestroy: ->
    EventsBus.$off 'contact-loaded', @contactLoaded
    EventsBus.$off 'Task::Done', @handleToggleDone

exports.default = helpers.vue_include(view_model, helpers.guid)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/events.vue